import { render, staticRenderFns } from "./offer-new.vue?vue&type=template&id=5cfb631b&"
import script from "./offer-new.vue?vue&type=script&lang=js&"
export * from "./offer-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports